import * as Yup from "yup";

export const emailValidationSchema = Yup.string()
  .required("Email ID is required")
  .matches(/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, "Invalid email format");

export const registrationSchema = Yup.object({
  firstName: Yup.string()
    .required("First name is required")
    .matches(/^[a-zA-Z\s]+$/, "Only alphabets allowed"),

  lastName: Yup.string()
    .required("Last name is required")
    .matches(/^[a-zA-Z\s]+$/, "Only alphabets allowed"),

  email: Yup.string()
    .required("Email ID is required")
    .matches(
      /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
      "Invalid email format"
    ),

  phoneNumber: Yup.string()
    .required("Phone number is required")
    .matches(/^[6-9]\d{9}$/, "Invalid  phone number"),
});

export const profilechangeSchema = Yup.object({
  firstName: Yup.string()
    .required("First name is required")
    .matches(/^[a-zA-Z\s]+$/, "Only alphabets allowed"),

  lastName: Yup.string()
    .required("Last name is required")
    .matches(/^[a-zA-Z\s]+$/, "Only alphabets allowed"),

  email: Yup.string()
    .required("Email ID is required")
    .matches(
      /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
      "Invalid email format"
    ),

  gender: Yup.string()
    .required("Gender is required")
    .oneOf(["male", "female", "other"], "Please select gender"),

  phone: Yup.string()
    .required("Phone number is required")
    .matches(/^[6-9]\d{9}$/, "Invalid  phone number"),

  dob: Yup.date()
    .required("Date of birth is required")
    .max(
      new Date(new Date().setFullYear(new Date().getFullYear() - 18)),
      "You must be at least 18 years old"
    )
    .typeError("Invalid date format"),

  panNumber: Yup.string()
    .required("PAN number is required")
    .matches(
      /[A-Z]{5}[0-9]{4}[A-Z]{1}/,
      "Invalid PAN format (e.g., ABCDE1234F)"
    ),

  aadharNumber: Yup.string()
    .required("Aadhar number is required")
    .matches(/^[2-9]{1}[0-9]{11}$/, "Invalid Aadhar number"),

  upiID: Yup.string()
    .required("UPI ID is required")
    .matches(/^[\w.-]+@[\w]+$/, "Invalid UPI ID"),

  addresses: Yup.object({
    home: Yup.string()
      .required("Home address is required")
      .min(10, "Address must be at least 10 characters"),

    work: Yup.string()
      .required("Work address is required")
      .min(10, "Address must be at least 10 characters"),

    other: Yup.string()
      .required("Other address is required")
      .min(10, "Address must be at least 10 characters"),
  }),
});
